import React from 'react'

import Certificate from 'app/PemetaanKompetensiPage/pages/Certificate'
import PageHeader from 'app/PemetaanKompetensiPage/components/PageHeader'
import { checkDateTimeServer } from 'app/PemetaanKompetensiPage/utils'

export async function getServerSideProps() {
  const currentDateTimeServer = await checkDateTimeServer()
  return {
    props: { currentDateTimeServer }, // will be passed to the page component as props
  }
}

const CertificatePage = ({ currentDateTimeServer }) => {
  return <Certificate currentDateTimeServer={currentDateTimeServer} />
}

const CertificatePageHeader = () => <PageHeader title="Sertifikat Kelulusan" />

CertificatePage.layoutOpts = {
  hasHeader: true,
  className: 'text-default bg-gray-10 !max-w-full !h-full min-h-screen',
  header: CertificatePageHeader,
}
export default CertificatePage
